import { type HTMLAttributes, type Ref } from 'react';
import clsx from 'clsx';
import './Badges.css';

export interface StreakFlameProps extends HTMLAttributes<HTMLSpanElement> {
  /** Current streak in days. */
  days: number;
  size?: 'sm' | 'md' | 'lg';
  /** When false, renders the grayed-out "streak broken / no activity today" state. */
  active?: boolean;
  ref?: Ref<HTMLSpanElement>;
}

/**
 * StreakFlame — orange flame + day count. On the home top bar.
 * When `active={false}` the flame turns gray — streak is at risk or broken.
 */
export function StreakFlame({ days, size = 'md', active = true, className, ref, ...rest }: StreakFlameProps) {
  return (
    <span
      ref={ref}
      className={clsx('fluent-badge', className)}
      data-kind="streak"
      data-size={size}
      data-inactive={!active || undefined}
      aria-label={active ? `${days}-დღიანი სტრიკი` : 'სტრიკი არ არის'}
      {...rest}
    >
      <span className="fluent-badge__icon" aria-hidden="true">
        <FlameIcon />
      </span>
      <span className="fluent-badge__value">{days}</span>
    </span>
  );
}

function FlameIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
      <path d="M12 2c1 3 3 5 3 8a3 3 0 1 1-6 0c0-1.5.5-2.5 1.2-3.4C9 7.5 8 8.3 8 10c-2.5 1.5-4 4-4 7 0 3.9 3.6 7 8 7s8-3.1 8-7c0-6-4.5-9-8-15z" />
    </svg>
  );
}
